import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { Store } from '@ngrx/store'
import { firstValueFrom } from 'rxjs'
import { AppState } from '../core/store'
import { selectAuthState } from '../core/store/auth/auth.selectors'
import { AuthService } from '../auth.service'

export const msalLoginGuard: CanActivateFn = async () => {
  const store = inject(Store<AppState>)
  const authService = inject(AuthService)

  const authState = await firstValueFrom(store.select(selectAuthState))

  if (authState.authenticated) {
    return true
  }

  // initOnAppStart already redirected to MSAL if no session was found.
  // This is a safety fallback for routes activated before initOnAppStart completes.
  await authService.loginRedirect()
  return false
}
